import { ModalBody as ModalBody_ } from 'reactstrap';
import styled from 'styled-components';

export const ModalBody = styled(ModalBody_)`
    ${ ({ overflowx }) => overflowx ? `overflow-x: ${ overflowx };` : '' }
`;
